var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.config.InnerStyle)},[_vm._v(_vm._s(_vm.value?_vm.value.substr(0,16):'-'))])
}
var staticRenderFns = []

export { render, staticRenderFns }